import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../web/components-v2/Theme/theme';

const { colors, common, queries, typography } = THEME;

export const styles = StyleSheet.create({
	page: {
		display: 'grid',
		gap: SPACE[24],
		gridTemplateColumns: 'minmax(0, 1fr) 320px',
		[queries.lg]: { gridTemplateColumns: 'minmax(0, 1fr)' },
	},
	main: { display: 'flex', flexDirection: 'column', gap: SPACE[24], minWidth: 0 },
	aside: { display: 'flex', flexDirection: 'column', gap: SPACE[16] },
	intro: { color: colors.text.light, fontSize: typography.fontSizes.md, lineHeight: 1.5, margin: 0 },
	step: {
		border: common.border,
		borderRadius: common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[12],
		padding: SPACE[20],
	},
	stepHeader: { alignItems: 'baseline', display: 'flex', gap: SPACE[12] },
	stepNumber: {
		alignItems: 'center',
		backgroundColor: colors.primary.main,
		borderRadius: common.borderRadiusPill,
		color: colors.primary.contrastText,
		display: 'inline-flex',
		flexShrink: 0,
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.bold,
		height: SPACE[24],
		justifyContent: 'center',
		width: SPACE[24],
	},
	stepTitle: { fontSize: typography.fontSizes.lg, fontWeight: typography.fontWeights.bold, margin: 0 },
	help: { color: colors.text.light, fontSize: typography.fontSizes.sm, lineHeight: 1.5, margin: 0 },
	optionList: { display: 'flex', flexDirection: 'column', gap: SPACE[8] },
	option: {
		alignItems: 'flex-start',
		border: common.border,
		borderRadius: common.borderRadius,
		cursor: 'pointer',
		display: 'flex',
		gap: SPACE[12],
		padding: SPACE[12],
	},
	optionSelected: { backgroundColor: colors.primary.light, borderColor: colors.primary.main },
	optionText: { display: 'flex', flexDirection: 'column', gap: SPACE[4] },
	optionTitle: { fontWeight: typography.fontWeights.semibold },
	pickList: {
		border: common.border,
		borderRadius: common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		maxHeight: 320,
		overflowY: 'auto',
	},
	pickItem: {
		':hover': { backgroundColor: colors.hover.light },
		alignItems: 'flex-start',
		borderBottom: `1px solid ${colors.border.light}`,
		cursor: 'pointer',
		display: 'flex',
		flexShrink: 0,
		gap: SPACE[12],
		padding: `${SPACE[8]}px ${SPACE[12]}px`,
	},
	pickItemSelected: { backgroundColor: colors.primary.light },
	pickItemMeta: { color: colors.text.light, display: 'block', fontSize: typography.fontSizes.xs },
	actions: { alignItems: 'center', display: 'flex', flexWrap: 'wrap', gap: SPACE[8] },
	tipCard: {
		backgroundColor: colors.background.main,
		borderRadius: common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[8],
		padding: SPACE[16],
	},
	batchCard: { border: `1px solid ${colors.primary.main}` },
	batchList: { display: 'flex', flexDirection: 'column', gap: SPACE[4], listStyle: 'none', margin: 0, padding: 0 },
	batchItem: {
		alignItems: 'center',
		display: 'flex',
		fontSize: typography.fontSizes.sm,
		gap: SPACE[8],
		justifyContent: 'space-between',
	},
	tipTitle: { fontSize: typography.fontSizes.md, fontWeight: typography.fontWeights.bold, margin: 0 },
	tipList: {
		color: colors.text.main,
		fontSize: typography.fontSizes.sm,
		lineHeight: 1.5,
		margin: 0,
		paddingLeft: SPACE[20],
	},
	callHeader: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		gap: SPACE[12],
		justifyContent: 'space-between',
	},
	callTitle: { fontSize: typography.fontSizes.lg, fontWeight: typography.fontWeights.bold, margin: 0 },
	transcript: { display: 'flex', flexDirection: 'column', gap: SPACE[12] },
	prospectLine: {
		alignSelf: 'flex-start',
		backgroundColor: colors.background.main,
		borderRadius: common.borderRadius,
		maxWidth: '80%',
		padding: SPACE[12],
	},
	repLine: {
		alignSelf: 'flex-end',
		backgroundColor: colors.primary.light,
		borderRadius: common.borderRadius,
		maxWidth: '80%',
		padding: SPACE[12],
	},
	speaker: { color: colors.text.light, display: 'block', fontSize: typography.fontSizes.xs, marginBottom: SPACE[4] },
	card: {
		backgroundColor: colors.background.light,
		border: `2px solid ${colors.primary.main}`,
		borderRadius: common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[12],
		padding: SPACE[16],
	},
	compareRow: {
		display: 'grid',
		gap: SPACE[12],
		gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
		[queries.md]: { gridTemplateColumns: 'minmax(0, 1fr)' },
	},
	sandboxCard: { borderColor: colors.secondary.main },
	pastCard: {
		border: common.border,
		borderRadius: common.borderRadius,
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		padding: SPACE[12],
	},
	cardLabel: {
		color: colors.primary.main,
		fontSize: typography.fontSizes.xs,
		fontWeight: typography.fontWeights.bold,
		textTransform: 'uppercase',
	},
	note: {
		alignItems: 'center',
		backgroundColor: colors.info.light,
		borderRadius: common.borderRadius,
		display: 'flex',
		fontSize: typography.fontSizes.sm,
		gap: SPACE[8],
		justifyContent: 'space-between',
		padding: `${SPACE[4]}px ${SPACE[8]}px`,
	},
	// Managers write long lines and notes here, so they can drag the box taller.
	resizableText: { minHeight: SPACE[64] + SPACE[32], resize: 'vertical' },
	composer: { display: 'flex', flexDirection: 'column', gap: SPACE[8] },
	stepCheck: {
		alignSelf: 'flex-end',
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		margin: 0,
		maxWidth: '80%',
		textAlign: 'right',
	},
	stepCheckEarned: { color: colors.success.dark, fontWeight: typography.fontWeights.semibold },
	status: { color: colors.text.light, fontSize: typography.fontSizes.sm, fontStyle: 'italic' },
	planBody: { maxHeight: '60vh', overflowY: 'auto' },
	reveal: { fontSize: typography.fontSizes.md, margin: 0 },
});
